import heic2any from 'heic2any';

const HEIC_MIME_TYPES = ['image/heic', 'image/heif'];
const HEIC_FILE_EXTENSION = /\.(heic|heif)$/i;

export const isHeicOrHeifImage = (file: File) =>
  HEIC_MIME_TYPES.includes(file.type.toLowerCase()) ||
  HEIC_FILE_EXTENSION.test(file.name);

export const convertHeicOrHeifToJpeg = async (file: File): Promise<File> => {
  if (!isHeicOrHeifImage(file)) {
    return file;
  }

  const conversionResult = await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.9,
  });
  const jpegBlob = Array.isArray(conversionResult)
    ? conversionResult[0]
    : conversionResult;
  const jpegFileName = HEIC_FILE_EXTENSION.test(file.name)
    ? file.name.replace(HEIC_FILE_EXTENSION, '.jpg')
    : `${file.name}.jpg`;

  return new File([jpegBlob], jpegFileName, {
    type: 'image/jpeg',
    lastModified: file.lastModified,
  });
};
